import { render, staticRenderFns } from "./custProfileDialog.vue?vue&type=template&id=18446774&scoped=true"
import script from "./custProfileDialog.vue?vue&type=script&lang=js"
export * from "./custProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./custProfileDialog.vue?vue&type=style&index=0&id=18446774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18446774",
  null
  
)

export default component.exports